/* import __COLOCATED_TEMPLATE__ from './post-subtotal-line-item.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/require-computed-property-dependencies */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import { computed } from '@ember/object';
import Component from '@ember/component';
export default Component.extend({
  pricedPerProduct: false,
  isSubtotal: false,
  label: undefined,
  priceUsd: undefined,
  formattedLabel: computed('label', function () {
    if (this.isSubtotal && this.pricedPerProduct) {
      return '';
    }
    return this.label;
  }),
});
